import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import PaymentSetting from '../entities/paymentSetting'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface PaymentSettingState extends ListState<PaymentSetting>{
    paymentSetting:PaymentSetting
    editPaymentSetting:PaymentSetting

}

class PaymentSettingMutations extends ListMutations<PaymentSetting>{

}

class PaymentSettingModule extends ListModule<PaymentSettingState,any,PaymentSetting>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<PaymentSetting>(),
        loading:false,
        editPaymentSetting:new PaymentSetting(),
        selectPaymentSetting:new PaymentSetting(),
      
    
    
    }
    actions={

        async selectPaymentSetting(context:ActionContext<PaymentSettingState,any>,payload:any){
            context.state.editPaymentSetting=payload.data;
        },
     
        async savePaymentSetting(context:ActionContext<PaymentSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.post('/api/services/app/Setting/SavePaymentSetting',payload.data);
          
            let page=reponse.data.result as PageResult<PaymentSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async updatePaymentSetting(context:ActionContext<PaymentSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.put('/api/services/app/Setting/UpdatePaymentSetting',payload.data);
          
            let page=reponse.data.result as PageResult<PaymentSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPaymentSettings(context:ActionContext<PaymentSettingState,any>,payload:any){
          
           // context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Setting/GetPaymentSettings',payload.data);
          
           // context.state.loading=false;
            let page=reponse.data.result as PageResult<PaymentSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
       
     
   
 
    };
    mutations={
        setCurrentPage(state:PaymentSettingState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:PaymentSettingState,pagesize:number){
            state.pageSize=pagesize;
        },
    }
}
const paymentSettingModule=new PaymentSettingModule();
export default paymentSettingModule;